module.exports = __webpack_public_path__ + "img/mt.5a6a5eb9.svg";